export default "__VITE_ASSET__BURv34lE__"